<section class="sh-dialog__content">
    <sh-form-radio-list
        [id]="'record-type-select'"
        [label]="'creation-flow.parent-select-dialog.parent-type' | translate: {amount: childCount,childType: translatedChildRecordType}"
        [control]="recordTypeControl"
        [items]="recordTypeOptions"
    ></sh-form-radio-list>
    <sh-form-multi-select
        id="parent-select"
        [label]="'creation-flow.parent-select-dialog.parent-selection' | translate: {parentType: (selectedRecordTypeTranslation$ | async)}"
        [control]="parentControl"
        [options]="parentOptions$ | async"
        [search]="true"
        [searchPlaceholderMsg]="'ui.search' | translate"
        [loadingMsg]="'ui.search-loading' | translate"
        [noResultsFoundMsg]="'ui.no-results' | translate"
        [listCappedMsg]="'ui.select.capped-results' | translate"
        [itemCapCount]="SEARCH_LIST_LIMIT"
        [inOverflownContainer]="true"
        [limitHeightToViewport]="true"
        (searchTerm)="onSearchTermChange($event)"
    >
    </sh-form-multi-select>
</section>
<footer class="sh-dialog__footer">
    <div class="sh-action-group -sh-align-end">
        <button type="button" class="sh-button sh-action-group__item" (click)="submit()" [disabled]="!parentSelectionFormGroup.valid">
            {{config.data.yes}}
        </button>
        <button type="button" class="sh-button--secondary sh-action-group__item" (click)="cancel()">{{config.data.no}}</button>
    </div>
    <div class="sh-action-group -sh-align-end"></div>
</footer>
